export const personalInfo = [
  { title: "Your full name;" },
  { title: "Your title;" },
  {
    title:
      "Your contact details (including street address, postal address, email address and phone number);",
  },
  { title: "Your time zone;" },
  { title: "Your gender;" },
  { title: "Your date of birth;" },
  { title: "Your next of kin;" },
  { title: "Location information;" },
  {
    title:
      "Transactional information including method of payment and your consultation dates and times;",
  },
  {
    title:
      "Your reasons for using the Website or the App or any of our products and services;",
  },
  {
    title:
      "Your preferences and opinions relating to the Website or any of our products and services;",
  },
  {
    title:
      "Logs, which may include information such as your Internet Protocol (IP) address, browser type, browser version, clickstream data, the pages of the Website or the App that you visit, the features of the Website and the App, activities or actions you do while using the Website and the App, the time and date of your visit to the Website and the App, the time spent on any pages of the Website and the App, the number of consultations that you have, the duration of each consultation, the technical performance of your video calls, and other log related information relating to your use of the Website and the App.",
  },
];

export const personal2 = [
  {
    title: "Through the Website and the App;",
  },
  {
    title: "Through our services;",
  },
  {
    title: "Through our account creation process on the Website and the App;",
  },
  {
    title: "From our users;",
  },
  {
    title: "Through marketing research including surveys;",
  },
  {
    title: "Through any of our other business activities or events;",
  },
  {
    title:
      "Through a person seeking employment with us, having been employed or contracted by us or being employed or contracted by us; and/or",
  },
  {
    title:
      "By otherwise having some form of contact with a person, such as by personal contact, mail, telephone, email, video teleconferencing, Internet or other forms of telecommunication.",
  },
];
export const useInfo = [
  {
    title:
      "Improving the Website, and the App, our other products and services, and user satisfaction;",
  },
  {
    title:
      "Providing and delivering the Website and the App and our other products and services to you;",
  },
  {
    title:
      "Providing support to you (including technical support) with regard to use of the Website and the App and our other products and services;",
  },
  {
    title:
      "Promoting and delivering our Site and our other products to organisations and individuals;",
  },
  {
    title:
      "Our internal research and statistical purposes (including market segmentation and customer value analysis); and",
  },
  {
    title:
      "Enabling us to forward to you other information or material which we believe may be of interest to you, or which you have indicated you may be interested in receiving.",
  },
];
export const Disclosure = [
  { title: "Providers;" },

  {
    title:
      "Our affiliates, including but not limited to other organisations and businesses within our group of organisations; and",
  },
  { title: "as permitted under the Privacy Act or any other applicable law." },
];

export const storageInfo = [
  {
    title:
      "Storing all our cloud information in India by way of a HIPAA and GDPR complaint server;",
  },
  { title: "External messaging of data is not permitted;" },
  {
    title:
      "Adopting measures to protect our computer systems and networks for storing, processing and transmitting personal information;",
  },
  {
    title:
      "Adopting procedural and personnel measures for limiting access to personal information by our staff;",
  },
  {
    title:
      "Regularly reviewing our information collection, storage and processing practices; and",
  },
  {
    title:
      "Secured encrypted servers, password protection for electronic files, multifactor authentication procedures, securing paper files in locked cabinets and physical access restrictions.",
  },
];
